<template>
  <div>
    <button
      title="Закрыть (Esc)"
      type="button"
      class="mfp-close"
      tabindex="0"
      @click="$parent.close()"
    >
      <img src="/button_close_popup_new.svg" alt="Закрыть" width="32" height="32">
    </button>
    <iframe
      ref="pollIframe"
      frameborder="no"
      scrolling="no"
      :style="{ height: iframeHeight + 'px' }"
      :src="src"
    />
  </div>
</template>

<script>
export default {
   name: 'PollModal',
   props: {
      src: String,
   },
  data() {
    return {
      iframeHeight: 0
    };
  },
  mounted() {
    this.updateWindowHeight();

    window.addEventListener('resize', this.updateWindowHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowHeight);
  },
  methods: {
    updateWindowHeight() {
      this.iframeHeight = window.innerHeight * 0.8;
    },
  },
};
</script>

<style scoped>
.mfp-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  line-height: 0 !important;
  font-size: 0 !important;
  color: transparent !important;
  opacity: 1 !important;
  z-index: 20;
}

.mfp-close::before,
.mfp-close::after {
  display: none !important;
  content: none !important;
}

.mfp-close img {
  display: block;
  width: 32px;
  height: 32px;
}

iframe {
  width: 100%;
}
</style>
